/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Chip,
  Grid2,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Download, ShareButton } from 'components/Download';

export default function Weather({ weather, month, year }) {
  const intl = useIntl();
  const [days, setDays] = useState([]);
  const [weatherData, setWeatherData] = useState({});
  const localeNav = useSelector((state) => state.prefs.locale);
  const tableRef = useRef();

  useEffect(() => {
    moment.locale(localeNav);
    const daysArray = [];
    const currentMonth = moment().month();
    const currentYear = moment().year();

    for (
      let i = 1;
      i <= moment(`${year}-${month}`, 'YYYY-MM').daysInMonth();
      i++
    ) {
      const date = moment({
        year: year || currentYear,
        month: (month || currentMonth) - 1,
        day: i,
      });
      const dateKey = date.format('YYYYMMDD');

      daysArray.push({
        day: i,
        weekday: date.format('ddd'),
        dateKey,
      });
    }

    setDays(daysArray);
  }, [localeNav, month, year]);

  useEffect(() => {
    const newWeatherData = {};

    for (const entry of Object.values(weather || {})) {
      newWeatherData[entry.date] = entry;
    }

    setWeatherData(newWeatherData);
  }, [weather]);

  return (
    <Paper sx={{ p: 2, overflowX: 'hidden', overflowY: 'auto' }}>
      <Grid2
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Chip
          label={intl.formatMessage({ id: 'app.temp.title' })}
          sx={{
            fontWeight: 700,
            backgroundColor: '#730065',
            fontSize: '16px',
            color: 'white',
          }}
        />
        <Box display="flex" gap={1}>
          <Download
            itemRef={tableRef}
            title={intl.formatMessage({ id: 'app.temp.title' })}
          />
          <ShareButton
            itemRef={tableRef}
            title={intl.formatMessage({ id: 'app.temp.title' })}
          />
        </Box>
      </Grid2>
      {days.length > 0 ? (
        <Box sx={{ width: '100%', overflowX: 'scroll', overflowY: 'hidden' }}>
          <Table ref={tableRef}>
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  {intl.formatMessage({
                    id: 'app.charge.board.totPerDay.label',
                  })}{' '}
                  C°
                </TableCell>
                {days.map((day) => (
                  <TableCell key={day.dateKey} align="center">
                    {day.day}
                    <br />
                    {day.weekday.charAt(0).toUpperCase() +
                      day.weekday.slice(1, 3)}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {['temp', 'temp_max', 'temp_min'].map((key) => (
                <TableRow key={key}>
                  <TableCell align="center" size="small">
                    {intl.formatMessage({
                      id: `app.${key === 'temp' ? 'tempProm' : key === 'temp_max' ? 'tempMax' : 'tempMin'}.title`,
                    })}
                  </TableCell>
                  {days.map((day) => {
                    const data = weatherData[day.dateKey] || {
                      [key]: 0,
                      [`${key}_color`]: 'white',
                    };
                    return (
                      <TableCell
                        key={day.dateKey}
                        align="center"
                        size="small"
                        sx={{
                          backgroundColor:
                            data[key] === 0 ? 'white' : data[`${key}_color`],
                          fontWeight: 'bold',
                          borderBottom: '5px solid #fff',
                        }}
                      >
                        {data[key]}°
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      ) : (
        <Skeleton variant="rectangular" width="100%" height={100} />
      )}
    </Paper>
  );
}
